<template>
  <div class="itt-img-detail-project" v-if="imgProjectProps" :class="{opacity: setOpacity}">
    <button @click="closeLightbox()">
      <v-icon class="close-lightbox">mdi-arrow-left</v-icon>
    </button>
    <div class="img-content">
      <div ref="imgList" class="img-list">
        <div :class="{visible: loader}" class="loader">
          <v-icon>mdi-loading mdi-spin</v-icon>
        </div>
        <img
          v-for="(url, index) in currentShow"
          @load="loaded"
          :key="index"
          :class="{'mb-4': !!index}"
          :src="url"
        >
      </div>
      <div>
        <input
          :class="{editting}"
          ref="inputName"
          :title="scopedName"
          v-model="scopedName"
          :readonly="!editting"
          class="name-image"
        >
        <button @click="editName()" v-if="!editting" class="edit-image">
          <v-icon>mdi-pencil</v-icon>
        </button>
        <button @click="saveName()" v-if="editting" class="edit-image">
          <v-icon>mdi-content-save</v-icon>
        </button>
        <button @click="cancelName()" v-if="editting" class="edit-image">
          <v-icon>mdi-close-circle</v-icon>
        </button>
      </div>
    </div>
    <div class="detail-content">
      <ul class="detail-list">
        <li class="pr-5 mb-3">
          <span>original</span>
          <div>
            <a @click="showImgs([imgProject.file_url])">
              <eye
                class="custom-icon"
                title="original image"
                :active="currentShow[0] === imgProject.file_url"
              ></eye>
            </a>
            <download class="custom-icon" title="download all"/>
          </div>
        </li>
        <li class="pr-5 mb-3">
          <span>basic</span>
          <div>
            <a
              v-if="imgProject.saliencyreport.heat_map"
              @click="showImgs([imgProject.saliencyreport.heat_map])"
            >
              <eye
                class="custom-icon"
                title="basic image"
                :active="currentShow[0] == imgProject.saliencyreport.heat_map"
              ></eye>
            </a>
            <v-icon v-else class="loader">mdi-spin mdi-loading</v-icon>
            <a v-if="imgProject.saliencyreport.bundle" :href="imgProject.saliencyreport.bundle">
              <download class="custom-icon" title="download basic" :active="false"/>
            </a>
            <v-icon v-else class="loader">mdi-spin mdi-loading</v-icon>
          </div>
        </li>
        <li class="pr-5 mb-3">
          <span>AOI 1</span>
          <div>
            <a
              v-if="imgProject.aoitestreport.length!=0"
              @click="showImgs([imgProject.aoitestreport[0].aoi_map])"
            >
              <eye class="custom-icon" title="aoi image" :active="false"></eye>
            </a>
            <v-icon v-else class="loader">mdi-spin mdi-loading</v-icon>
            <a v-if="imgProject.aoitestreport.length!=0" :href="imgProject.aoitestreport[0].bundle">

              <download class="custom-icon" title="download aoi" :active="false"/>
            </a>
            <v-icon v-else class="loader">mdi-spin mdi-loading</v-icon>
          </div>
        </li>
        <li class="pr-5 mb-3">
          <span>A/B test x</span>
          <div>
            <eye class="custom-icon" title="a/b test"></eye>
            <download class="custom-icon" :active="false"/>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import eye from "@/components/icons/eye";
import download from "@/components/icons/download";
export default {
  components: {
    eye,
    download
  },

  props: {
    imgProjectProps: Object || null
  },

  data() {
    return {
      setOpacity: !!this.imgProject,
      scopedName: "",
      extentionName: "",
      editting: false,
      currentShow: [],
      imgProject: null,
      checkDataInterval: null,
      loader: true
    };
  },

  watch: {
    imgProjectProps() {
      if (!!this.imgProjectProps) {
        this.imgProject = this.imgProjectProps;
        let splittedName = this.imgProject.name.split(".");
        this.extentionName = splittedName.length > 1 ? splittedName.pop() : "";
        this.scopedName = splittedName.join(".");
        this.currentShow = [this.imgProject.file_url];
        this.changeSizeFrame();
        this.checkDatas();
      }
    },
    currentShow() {
      this.loader = true;
    }
  },

  methods: {
    loaded() {
      this.loader = false;
    },
    closeLightbox() {
      this.setOpacity = false;
      this.$emit("closed");
      clearInterval(this.checkDataInterval);
    },
    editName() {
      this.editting = true;
      this.$refs.inputName.focus();
    },
    saveName: async function() {
      if (!this.scopedName) return;
      this.editting = false;
      let separator = this.extentionName.length ? "." : "";
      let newName = this.scopedName + separator + this.extentionName;
      await this.$store.dispatch("image/updateMediaName", [
        this.imgProject.uuid,
        newName
      ]);
      this.$store.dispatch("image/getImages");
    },
    cancelName() {
      this.editting = false;
      let splittedName = this.imgProject.name.split(".");
      this.extentionName = splittedName.length > 1 ? splittedName.pop() : "";
      this.scopedName = splittedName.join(".");
    },
    showImgs(urls) {
      this.currentShow = urls;
    },
    checkDatas() {
      if (!this.imgProject) return;
      let toCheck = ["saliencyreport.heat_map", "saliencyreport.bundle"];
      this.checkDataRecursive(toCheck);
    },
    checkDataRecursive(toCheck) {
      if (toCheck.length === 0) {
        return;
      }
      if (!this.byString(this.imgProject, toCheck[0])) {
        this.checkDataInterval = setInterval(() => {
          this.$store
            .dispatch("image/getImg", this.imgProject.uuid)
            .then(img => {
              if (!!this.byString(img, toCheck[0])) {
                this.imgProject = img;
                this.currentShow = [this.imgProject.file_url];
                this.$store.dispatch("image/getImages");
                toCheck.shift();
                clearInterval(this.checkDataInterval);
                this.checkDataRecursive(toCheck);
              }
            });
        }, 5000);
      } else {
        toCheck.shift();
        this.checkDataRecursive(toCheck);
      }
    },
    // Ajuste la taille du cadre de l'image (fonctionne avec des images width >> et height < ou height >> et width <)
    changeSizeFrame() {
      setTimeout(() => {
        this.setOpacity = true;
        let borderDiv = this.$refs.imgList;
        let borderDivStyle = getComputedStyle(borderDiv);
        let borderDivWidth = parseInt(borderDivStyle.width);
        let borderDivHeight = parseInt(borderDivStyle.height);
        let img = document.querySelector(".img-list>img");

        if (this.imgProject.width < borderDivWidth)
          this.$refs.imgList.style.width = this.imgProject.width + "px";
        else {
          let rapport = this.imgProject.height / this.imgProject.width;
          if (borderDivWidth * rapport < borderDivHeight)
            this.$refs.imgList.style.height = borderDivWidth * rapport + "px";
        }
      }, 10);
    },
    byString(o, s) {
      s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
      s = s.replace(/^\./, ""); // strip a leading dot
      var a = s.split(".");
      for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }
      return o;
    }
  }
};
</script>

<style lang="sass" scoped>
$main-background: #1d1d1b
$name-color: #b2b2b2
$main-border: #989898
.itt-img-detail-project
  position: fixed
  display: flex
  top: 0
  bottom: 0
  right: 0
  background-color: $main-background
  z-index: 9
  width: calc(100% - 238px)
  // padding: 64px 0 40px 0
  opacity: 0
  transition: all ease .4s
  &.opacity
    opacity: 1
  @media screen and (max-width: 1264px) // plus petit que 1264, width: 100%
    width: 100%
  .close-lightbox
    position: absolute
    top: 80px
    left: 50px
    font-size: 3rem

  .img-content, .detail-content
    text-align: center
    margin-top: 75px
    align-self: center
  .img-content
    width: 75%
    .img-list 
      border: 2px solid $main-border
      max-width: 90%
      margin: auto
      height: calc(70vh - 50px)
      overflow-y: scroll
      img 
        max-width: 100%
        // margin-bottom: 3rem
  .detail-content
    width: 25%
    ul.detail-list
      overflow-y: scroll
      margin: auto
      height: calc(70vh)
      list-style: none
      text-transform: uppercase
      font-size: 1.7rem
      li
        display: flex
        justify-content: space-between
        span 
          display: flex
          align-items: center
        div
          display: flex 
          align-items: center
          .loader 
            width: 3rem
            font-size: 2.2rem
            margin-left: 1rem
      .custom-icon 
        width: 3rem  
        margin-left: 1rem
        cursor: pointer

  .name-image, .edit-image
    margin: 10px 1rem
    // word-break: break-all
    color: $name-color
    font-size: 1.3rem
    background-color: #30302e
    padding: .3rem 1rem .1rem
    >i 
      color: $name-color
  .name-image 
    overflow: hidden
    text-overflow: ellipsis
    white-space: nowrap
    text-transform: uppercase
    width: 50%
    &.editting 
      text-transform: unset
      width: 44%
  input[readonly="readonly"]
    outline: 0
    cursor: default
  .img-list
    position: relative
    .loader 
      position: absolute 
      top: 50%
      left: 50%
      transform: translate(-50%, -50%)
      opacity: 0
      transition: all ease .4s
      &.visible
        opacity: 1
      i
        font-size: 4rem
  

</style>
